import PropTypes from 'prop-types'
import React from 'react'
import { Card, CARD_ELEVATION, CARD_PADDING_SIZE } from 'components/Card'
import { Flex } from 'components/Layout'
import { H5, Text } from 'components/Typography'
import { COLOR, FONT_SIZE, FONT_STACK, SPACE } from 'Theme'
import { useMedia } from 'useMedia'

const Testimonial = ({
  feedback,
  clientName,
  consultationName,
  expertName,
}) => {
  const media = useMedia()
  const mobileFont = { ...(media.MOBILE ? { fontSize: FONT_SIZE.PX_12 } : {}) }
  return (
    <Card
      paddingSize={
        media.MOBILE ? CARD_PADDING_SIZE.DEFAULT : CARD_PADDING_SIZE.XXLARGE
      }
      elevation={CARD_ELEVATION.NONE}
      overflow="hidden"
    >
      <Flex width="100%" flexDirection="column" justifyContent="space-between">
        <Flex flexDirection="column" justifyContent="center">
          <Text
            textAlign="center"
            fontSize={media.MOBILE ? FONT_SIZE.PX_14 : FONT_SIZE.PX_16}
            fontFamily={FONT_STACK.SERIF}
          >
            {`"${feedback}"`}
          </Text>
          <H5 textAlign="center" mt={SPACE.PX_30}>
            {clientName}
          </H5>
        </Flex>
        <Flex mt={SPACE.PX_30} justifyContent="space-between">
          <Flex flexDirection="column">
            {consultationName && (
              <Text {...mobileFont}>{consultationName}</Text>
            )}
            {expertName && (
              <Text
                {...mobileFont}
                {...(consultationName ? { marginTop: SPACE.PX_5 } : {})}
                fontStyle="italic"
                color={COLOR.GRAYSCALE_2}
              >
                {expertName}
              </Text>
            )}
          </Flex>
          <Flex alignItems="flex-end">
            <Text {...mobileFont} textAlign="right" color={COLOR.PRIMARY_1}>
              Verified by The Expert
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}

Testimonial.propTypes = {
  feedback: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  consultationName: PropTypes.string,
  expertName: PropTypes.string,
}

export default Testimonial
